import React from 'react'

export const CurrentUserContext = React.createContext<{
  currentUser?: Api_UserMe.RootObject
}>({ currentUser: undefined })
